module.exports = __webpack_public_path__ + "media/images/common/h3_info-b4854f3be9ebb6a938f58c51eaa6a05e.gif";